import { createFileRoute } from '@tanstack/react-router';
import { BankAccountSettingsPage } from '@/components/finance/bank-ingestion';

/**
 * PPR-017 — Settings → Bank Accounts. Lists every <c>BankAccount</c> in the
 * campaign and lets the treasurer edit "how we read your statements" against
 * each one's active <c>BankSourceProfile</c>.
 */
export const Route = createFileRoute('/admin/finance/settings/bank-accounts')({
  component: BankAccountSettingsPage,
});
